/**
 * "Unique Impact" section of the Ryerson Gives Back page
 * (`src/pages/why-ryerson/ryerson-commitment/ryerson-gives-back/index.tsx`, its only importer): a
 * globe icon and two paragraphs on the charities Ryerson partners with. From `lg` up it renders
 * `./UniqueImpactDesktop.tsx` (the Environment, Health & Safety Job Safety layout), below `lg`
 * `./UniqueImpactMobile.tsx`. Copy: `./UniqueImpactContent.tsx`.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import UniqueImpactDesktop from "./UniqueImpactDesktop";
import UniqueImpactMobile from "./UniqueImpactMobile";
import { UniqueImpactContent } from "./UniqueImpactContent";
import { useApplication } from "@ryerson/frontend.application";

/**
 * Props of both layouts: `JobSafetyProps` from
 * `../../EnvironmentHealthSafety/JobSafety/JobSafety.tsx` without `noSecondarySection`.
 */
export interface UniqueImpactProps {
	/** The icon beside (desktop) or below (mobile) the paragraphs. */
	imageUrl?: string;
	/** Drawn as the heading from `lg` up only; on mobile the page's accordion tab shows it. */
	title: string;
	paragraph1: string;
	paragraph2: string;
}

/** Renders the section in the visitor's language, falling back to English. Takes no props. */
const UniqueImpact: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	const uniqueImpactContent = UniqueImpactContent[language] || UniqueImpactContent.en;

	return (
		<>
			<Media lessThan="lg">
				<UniqueImpactMobile {...uniqueImpactContent} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<UniqueImpactDesktop {...uniqueImpactContent} />
			</Media>
		</>
	);
};

export default UniqueImpact;
